import { Acoes } from "./acoes";
import { ColaboradoresAtividade } from './colaboradores-atividade';
import { Contrato } from "./contrato";
import { MateriaisAtividade } from './materiais-atividade';
import { ObjetivoAtividade } from "./objetivo-atividade";
import { Percurso } from "./percurso";
import { Programa } from './programa';
import { Projeto } from './projeto';
import { PublicoAlvoAtividade } from "./publico-alvo-atividade";
import { TiposAtividades } from './tipos-atividades';
import { Unidade } from './unidade';

export class Atividade {
    id: number;
    descricao: string;
    descricaoMetodologia: string;
    descricaoLocalExecucao: string;
    dataFim: Date;
    dataInicio: Date;
    horaFim: number;
    horaInicio: number;
    cargaHoraria: number;
    maximoParticipantes: number;
    quantidadeParticipantes: number;
    domingo: string;
    localExecucao: string;
    quarta: string;
    quinta: string;
    sabado: string;
    segunda: string;
    sexta: string;
    terca: string;
    area: string;
    valorCustoAtividade: number;

    contrato: Contrato;
    projeto: Projeto;
    programa: Programa;
    unidade: Unidade;
    percurso: Percurso;

    idTurma: number;

    colaboradoresAtividade: ColaboradoresAtividade[];
    materiaisAtividade: MateriaisAtividade[];
    objetivosAtividade: ObjetivoAtividade[];
    acoes: Acoes[];
    publicosAlvosAtividade: PublicoAlvoAtividade[];
    tiposAtividades:TiposAtividades;

    usuarioAlteracao: number;

    descricaoPublicoAlvo: string;
}